import React, { useState } from 'react';
import Popup from '../Modals/Popup';

export default function DeleteItem({ leadData,updateLeadDataMultiple }) {

  const deleteAppointment = async () => {
    var values = {
        'id': leadData.id,
        'appointment_date': null,
        'lead_type': leadData.lead_type,
        'appraisal_stage': leadData.appraisal_stage
    }
    const response = await updateLeadDataMultiple(values);
    console.log(response);
  }

  return ( <button onClick={deleteAppointment} className="dropdown-item text-danger font-bold text-uppercase" type="button">Delete</button>);
}
